import { render, staticRenderFns } from "./SmenuEdit.vue?vue&type=template&id=8604731e&scoped=true"
import script from "./SmenuEdit.vue?vue&type=script&lang=js"
export * from "./SmenuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8604731e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8604731e')) {
      api.createRecord('8604731e', component.options)
    } else {
      api.reload('8604731e', component.options)
    }
    module.hot.accept("./SmenuEdit.vue?vue&type=template&id=8604731e&scoped=true", function () {
      api.rerender('8604731e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/menus/SmenuEdit.vue"
export default component.exports